import { render, staticRenderFns } from "./AdminTrainintRetailerBrandProductDialog.vue?vue&type=template&id=47137d04&scoped=true"
import script from "./AdminTrainintRetailerBrandProductDialog.vue?vue&type=script&lang=js"
export * from "./AdminTrainintRetailerBrandProductDialog.vue?vue&type=script&lang=js"
import style0 from "./AdminTrainintRetailerBrandProductDialog.vue?vue&type=style&index=0&id=47137d04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47137d04",
  null
  
)

export default component.exports